import React from 'react'
import styles from './styles.module.css'
import ToggleIcon from '../icons/ToggleIcon'

function Toggle({ onToggle, toggled }) {
  return (
    <div
      className={toggled ? `${styles.toggleWrapper} ${styles.toggleWrapperToggled}` : styles.toggleWrapper}
      onClick={onToggle}
    >
      <div
        className={toggled ? `${styles.toggleIconWrapper} ${styles.toggleIconWrapperToggled}` : styles.toggleIconWrapper}
        style={toggled ? { '--toggle-icon-color': '#fff' } : undefined}
      >
        <ToggleIcon color="currentColor"/>
      </div>
    </div>
  )
}

export default Toggle
